import { FC } from "react";
import { ActivityBodyInfoProps } from "./types";
import ActivityBody from "../ActivityBody";
import { Text } from "../../../../typography";
import { useThemeStore } from "../../../../../stores";
import { ActivityRendererType } from "../../../types";

const ActivityBodyInfo: FC<ActivityBodyInfoProps> = ({
  title,
  value,
  type,
  props,
  className = "",
  style = {},
}) => {
  const theme = useThemeStore((state) => state.theme);
  const COLOR =
    type === ActivityRendererType.Big ? theme.textOnOverlay : theme.textOnBg;
  return (
    <ActivityBody
      className={className}
      props={props}
      style={{ gap: 5, ...style }}
    >
      <Text size={11} color={COLOR}>{`${title} :`}</Text>
      <Text size={11} color={COLOR}>
        {value}
      </Text>
    </ActivityBody>
  );
};

export default ActivityBodyInfo;
